import { createStyles } from 'utils/css'
import theme from 'utils/theme'

import {
  IDashboardLayout,
  IDefaults,
  ISideStyles
} from './DashboardLayout.types'

const { spacing, mediaQuery } = theme

export const wrapper = ({ breakpoint, mobileHeaderHeight }, styles) =>
  createStyles(({ mediaQuery, size, spacing }) => {
    const defaultStyles = {
      padding: spacing([1, 1, 2]),
      maxWidth: size(144),
      [mediaQuery('xs', 'min-width')]: {
        padding: spacing(1)
      },
      [mediaQuery(breakpoint)]: {
        padding: spacing(4)
      },
      [mediaQuery(breakpoint, 'max-width')]: {
        marginTop: size(mobileHeaderHeight)
      },
      '@media (min-height: 1000px)': {
        paddingTop: spacing(4)
      }
    }

    return { ...defaultStyles, ...styles?.wrapper }
  })

export const sidebar = (
  { breakpoint, sideWidth }: Pick<IDefaults, 'breakpoint' | 'sideWidth'>,
  { styles }: Pick<IDashboardLayout, 'styles'>
) =>
  createStyles(({ justifications, mediaQuery, size }) => {
    const defaultStyles = {
      display: 'none',
      [mediaQuery(breakpoint)]: {
        display: 'flex',
        justifyContent: justifications.end
      },

      '& header': {
        width: size(sideWidth)
      }
    }
    return { ...defaultStyles, ...styles?.sidebar }
  })

export const sidebarContent = (styles?: ISideStyles): ISideStyles => ({
  outer: {
    height: '100%',
    position: 'fixed',
    width: '250px',
    ...styles?.outer
  },
  inner: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
    ...styles?.inner
  }
})

export const logo = (
  {
    breakpoint,
    mobileHeaderHeight
  }: Pick<IDefaults, 'breakpoint' | 'mobileHeaderHeight'>,
  { styles }: Pick<IDashboardLayout, 'styles'>
) =>
  createStyles(({ size }) => {
    const defaultStyles = {
      height: size(mobileHeaderHeight),
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      [mediaQuery(breakpoint)]: {
        height: 'auto',
        margin: `0 0 ${spacing(2)}`,
        padding: spacing([0, 1])
      }
    }

    return { ...defaultStyles, ...styles?.logo }
  })

export const navStylesMobile = ({
  breakpoint,
  mobileHeaderHeight
}: IDefaults) =>
  createStyles(({ alignments, justifications, mediaQuery, size }) => ({
    justifyContent: justifications.center,
    alignItems: alignments.start,
    zIndex: 9,
    height: size(mobileHeaderHeight),
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    '& header': {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(1)
    },
    [mediaQuery(breakpoint)]: {
      display: 'none'
    }
  }))

export const menu = () =>
  createStyles(({ size }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    width: size(3.2),
    height: size(3.2),
    zIndex: 9,
    paddingRight: spacing(1)
  }))
